<div class="offcanvas offcanvas-end" tabindex="-1" id="detail-esports"
  aria-labelledby="offcanvasRightLabel">
  <ng-container *ngIf="DetaileSports">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">[{{DetaileSports.gameProvider}}] Bill</h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body" [ngClass]="{'text-decoration-line-through': DetaileSports.gameResult == 'CANCEL'}">
      เลขตั๋ว : {{DetaileSports.betId}} <br>
      GAME ID : {{DetaileSports.gameBetId}}<br>
      Bet Date/Time : {{DetaileSports.timeBet | date:'dd/MM/yyyy HH:mm'}} <br>
      Settle Date/Time : {{DetaileSports.timeSettle | date:'dd/MM/yyyy HH:mm'}} <br>
      Type : {{DetaileSports.gameName}}<br>
      <hr>
      <div class="table-responsive">
        <table class="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>รายละเอียด</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of DetaileSports.winlose_detail_tf;let i = index">
              <td>
                {{i+1}}
              </td>
              <td class="text-start">
                <div class="text-start">
                  <span class="d-block-inline border px-3 py-1 bg-se"
                    [ngClass]="{'text-decoration-line-through': DetaileSports.gameResult == 'CANCEL'}">
                    Game : {{data.game_type_name || 'no game'}}
                  </span>
                  <br>
                  <span class="d-block-inline border px-3 py-1 bg-se"
                    [ngClass]="{'text-decoration-line-through': DetaileSports.gameResult == 'CANCEL'}">
                    <i class="bi bi-trophy"></i> Competition Name : {{data.competition_name || 'no game'}}
                  </span>
                </div>
                <div class=" border-start ">
                  <span class="ps-2 text-primary"
                    [ngClass]="{'text-decoration-line-through': DetaileSports.gameResult == 'CANCEL'}">
                    H : {{data.event_name.split(' vs ')[0]}}
                  </span>
                  <div class="ps-2">-vs-</div>
                  <span class="ps-2 text-danger"
                    [ngClass]="{'text-decoration-line-through': DetaileSports.gameResult == 'CANCEL'}">
                    A : {{data.event_name.split(' vs ')[1]}}
                  </span>
                </div>
                <div>Play Time : {{data.event_datetime |date:'dd/MM HH:mm:ss'}} </div>
                <div class="text-uppercase">
                  Bet :
                  <span *ngIf="data.bet_selection == 'home'" class="text-primary">
                    {{data.bet_selection}}
                  </span>
                  <span *ngIf="data.bet_selection != 'home'" class="text-danger">
                    {{data.bet_selection}}
                  </span>
                </div>
                <div>Bet Type : {{data.bet_type_name}} </div>
                <div class="ff-number text-underline">
                  <strong>{{data.member_odds}}</strong>
                </div>
                <div>
                  Status :
                  <span *ngIf="data.result"
                    [ngClass]="{'text-success':data.result.toUpperCase().startsWith('W') , 'text-danger':data.result.toUpperCase().startsWith('L')}">
                    {{data.result.toUpperCase()}}
                  </span>
                  <span *ngIf="!data.result">
                    RUNNING
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr>
      <div class="d-flex">
        <span class="w-50">Bet Amount</span>
        <span class="w-50 text-end">{{DetaileSports.betAmt | number : '.2-2'}} THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50">Discount</span>
        <span class="w-50 text-end">0.00 THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50"> Odds ({{DetaileSports.gameOddsStyle}})</span>
        <span class="w-50 text-end">{{DetaileSports.gameOdds}} THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50">Status</span>
        <span class="w-50 text-end">
          <ng-container *ngIf="DetaileSports.gameStatus === 'done'">
            <span *ngIf="DetaileSports.gameResult === 'win' || DetaileSports.gameResult === 'won'">
              WIN
            </span>
            <span
              *ngIf="DetaileSports.gameResult === 'los' || DetaileSports.gameResult === 'lose' || DetaileSports.gameResult === 'loss'">
              LOSE
            </span>
            <span class="text-uppercase" *ngIf="DetaileSports.gameResult === 'draw'">
              {{DetaileSports.gameResult}}
            </span>
          </ng-container>
          <ng-container *ngIf="DetaileSports.gameStatus !== 'done'">
            <span>RUNNING</span>
          </ng-container>
        </span>
      </div>
      <hr>
      <div class="d-flex">
        <span class="w-50">Total</span>
        <span class="w-50 text-end text-underline">{{DetaileSports.winLose}} THB</span>
      </div>
    </div>
  </ng-container>
</div>
